<template>
  <div class="color-settings">
    <h2>Color Settings</h2>
    <div class="wrapper">
      <ColorPicker
        v-for="el in colorPickerDataWithColors"
        :key="el.idx"
        :title="el.title"
        :label="el.label"
        :color="el.color"
        :idx="el.idx"
        @emitColor="handleEmitColor"
      />
    </div>
  </div>
</template>

<script>
import ColorPicker from "./ColorPickerComponent.vue";
export default {
  components: {
    ColorPicker,
  },
  props: {
    colors: {
      type: Object,
    },
  },
  data() {
    return {
      colorPickerData: [
        {
          idx: 0,
          title: "Footer Background",
          label: "You can set your footer section background color here.",
        },
        {
          idx: 1,
          title: "Text Color",
          label: "You can set your footer text color here.",
        },
        {
          idx: 2,
          title: "Links Color",
          label: "You can set your footer section links color here.",
        },
        {
          idx: 3,
          title: "Icon Color",
          label:
            "You can set your footer section social media & report bug icons color here.",
        },
        {
          idx: 4,
          title: "Powered by Background Color",
          label: "You can set the background color of Powered by section.",
        },
      ],
    };
  },
  computed: {
    colorPickerDataWithColors () {
      return this.colorPickerData.map(el => {
        if (el.idx === 0) el.color = this.colors.background;
        if (el.idx === 1) el.color = this.colors.text_color;
        if (el.idx === 2) el.color = this.colors.links_color;
        if (el.idx === 3) el.color = this.colors.icon_color;
        if (el.idx === 4) el.color = this.colors.powered_by_color;

        return el;
      });
    },
  },
  methods: {
    handleEmitColor(payload) {
      this.$emit("emitColor", payload);
    },
  },
};
</script>

<style lang='scss' scoped>
.color-settings {
  h2 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #001529;
    margin: 50px 0 0 0;
    border-bottom: 1px solid #cbcbe4;
    padding: 25px 0;
  }
  .wrapper {
    max-width: 566px;
  }
}
</style>